import { useState } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { DropOffModal } from '../../../DropOffLocationsModal';

export const CTASelectDropOff = ({ shipment }) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button block variant="fulfilled" onClick={() => setIsOpen(true)}>
        {t('RETURN_SELECT_DROPOFF_LOCATION_CTA')}
      </Button>

      <DropOffModal
        shipment={shipment}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
